
import {
  getListIap,
  addIap,
  updateIap,
  removeIap,
} from '@/services/iap';

const getters = {
  listIap: state => state.listIap,
};

const actions = {
  async requestListIap({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const result = await getListIap(filter, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('SET_LIST_IAP', result.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestAddIap({ commit, dispatch, rootGetters }, iap) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await addIap(iap, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListIap');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestUpdateIap({ commit, dispatch, rootGetters }, iap) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await updateIap(iap, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListIap');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestRemoveIap({ commit, dispatch, rootGetters }, iap) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await removeIap(iap, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListIap');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST_IAP(state, listIap) {
    state.listIap = listIap;
  },
};

export default {
  namespaced: true,
  state: {
    listIap: {},
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/IAP/index.js